import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import {
  Wrapper,
  PageContent,
  Title,
  TitleWrapper,
  Subtitle,
  // Input,
  TermOfUseText,
  TermOfUseTextPlaceholderWrapper,
  Button,
  ErrorMessageWrapper,
  // ButtonPlaceholder,
  Text,
  Anchor,
  Spinner,
  // InputWrapper,
  Overlay,
  OverlayModal,
  CloseButton,
  ErrorMessage,
} from './SignUpPage.style';
import { BLACK } from '../../../styles/variables.style';
import Placeholder from '../../../components/Placeholder';
import Modal from '../../../components/Modal/RecieverFragments';
import { TABLET_P } from '../../../constants';

class CodeForm extends React.Component {
  // const CodeForm = ({ copy, onInputChange, onCodeSubmit, isValidCodeForm, locale, code, loading, error }) => (
  state = {
    // code: '',
    openModal: false,
    isShowOverlay: false,
    isAgree: false,
    isShowError: false,
  };

  componentDidMount() {
    this.checkSalonCode();
  }

  onChangeAgree = () => {
    this.setState({
      isAgree: !this.state.isAgree,
      isShowError: false,
    });
  };

  getParam = (name, url) => {
    let nameString = name;
    let urlString = url;
    if (!urlString) urlString = window.location.href;
    nameString = nameString.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${nameString}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(urlString);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };

  checkSalonCode = () => {
    const salonCode = this.getParam('salonCode', window.location.href);
    const { onCodeSubmit } = this.props;

    if (salonCode) {
      this.setState(
        {
          code: salonCode,
        },
        () => {
          onCodeSubmit(salonCode);
        }
      );
    }
  };

  openModal = e => {
    this.setState({ openModal: true });
    e.preventDefault();
    return false;
  };

  closeModal = e => {
    this.setState({ openModal: false });
    if (e) {
      e.preventDefault();
    }
    return false;
  };

  closeOverlay = e => {
    // this.setState({ isShowOverlay: false });
    const { locale } = this.props;
    window.location.href = `/${locale}/salon-consultation/login`;
    if (e) {
      e.preventDefault();
    }
    return false;
  };

  gotoForm = e => {
    const { handleSubmit } = this.props;
    if (this.state.isAgree) {
      handleSubmit();
    } else {
      this.setState({
        isShowError: true,
      });
    }
    e.preventDefault();
    return false;
  };

  render() {
    const {
      copy,
      errorMessage,
      terms,
      onInputChange,
      onCodeSubmit,
      isValidCodeForm,
      isCodeValid,
      locale,
      code,
      loading,
      error,
    } = this.props;
    return (
      <Wrapper>
        <PageContent>
          <TitleWrapper>
            {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
              <Title>{copy.signUp}</Title>
            ) : (
              <Placeholder h="40px" w={window.innerWidth > TABLET_P ? '500px' : '100%'} />
            )}
          </TitleWrapper>
          <TitleWrapper>
            <Subtitle style={{ marginBottom: '20px', fontSize: '22px' }}>
              {copy.econSignUpTitle || <Placeholder h="20px" w="300px" />}
            </Subtitle>
          </TitleWrapper>
          <React.Fragment>
            {!(_.get(copy, 'signupTerms') && _.get(copy, 'signupTermsLink')) ? (
              <TermOfUseTextPlaceholderWrapper>
                <Placeholder h="20px" w="300px" />
              </TermOfUseTextPlaceholderWrapper>
            ) : (
              <TermOfUseText>
                <p>
                  <label>
                    <input
                      type="checkbox"
                      name="agree"
                      checked={this.state.isAgree}
                      onChange={event => this.onChangeAgree(event)}
                    />
                    {` ${copy.signupTerms}`}
                  </label>
                </p>
                <p>
                  <a
                    href={`/${locale}/terms-of-use`}
                    style={{ fontSize: '14px', color: BLACK, fontWeight: '800', textDecoration: 'underline' }}
                    onClick={this.openModal}
                  >
                    {copy.signupTermsLink}
                  </a>
                </p>
              </TermOfUseText>
            )}
          </React.Fragment>
          {this.state.isShowError && (
            <ErrorMessageWrapper>
              {errorMessage && <p style={{ color: 'red', fontSize: '12px' }}>{errorMessage.notAgree}</p>}
            </ErrorMessageWrapper>
          )}
          <Button type="button" onClick={this.gotoForm} className={!this.state.isAgree ? 'disabled' : null}>
            {loading ? <Spinner /> : copy.econSignUpNext}
          </Button>
          {/* <form onSubmit={onCodeSubmit} style={{ display: 'block' }}>
            <InputWrapper style={{ marginBottom: '30px' }}>
              <Input type="text" placeholder={copy.codePlaceholder} value={code} onChange={onInputChange('code')} />
            </InputWrapper>
            <React.Fragment>
              {!(_.get(copy, 'signupTerms') && _.get(copy, 'signupTermsLink')) ? (
                <TermOfUseTextPlaceholderWrapper>
                  <Placeholder h="20px" w="300px" />
                </TermOfUseTextPlaceholderWrapper>
              ) : (
                <TermOfUseText>
                  {copy.signupTerms}{' '}
                  <a
                    href={`/${locale}/terms-of-use`}
                    style={{ fontSize: '14px', color: BLACK, fontWeight: '800', textDecoration: 'underline' }}
                    onClick={this.openModal}
                  >
                    {copy.signupTermsLink}
                  </a>
                </TermOfUseText>
              )}
            </React.Fragment>
            <ErrorMessageWrapper>
              {error && <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>}
            </ErrorMessageWrapper>
            <React.Fragment>
              {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
                <Button type="submit" disabled={!isValidCodeForm() || loading}>
                  {loading ? <Spinner /> : copy.submit}
                </Button>
              ) : (
                <ButtonPlaceholder>
                  <Placeholder h="60px" w="300px" />
                </ButtonPlaceholder>
              )}
            </React.Fragment>
          </form> */}
          <React.Fragment>
            {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
              <React.Fragment>
                <Text>{copy.alreadyHaveAccount}</Text>
                <Link to={`/${locale}/salon-consultation/login`} href={`/${locale}/salon-consultation/login`}>
                  <Anchor>{copy.signIn}</Anchor>
                </Link>
              </React.Fragment>
            ) : (
              <Placeholder h="60px" w="250px" />
            )}
          </React.Fragment>
        </PageContent>
        <Modal
          isOpen={this.state.openModal}
          hasHeader
          onClose={this.closeModal}
          contentBodyItems={[
            {
              type: 'MARKDOWN_DATE',
              item: terms,
            },
          ]}
          styleType="signUpType"
        />
        <Overlay visible={isCodeValid === false || !this.state.code}>
          {copy.signUp ? (
            <OverlayModal>
              <CloseButton onClick={this.closeOverlay} type="button">
                ×
              </CloseButton>
              <Title>{copy.signUp || <Placeholder h="40px" w="200px" />}</Title>
              <ErrorMessage>
                {this.state.code ? errorMessage.econSignUpError1 : errorMessage.econSignUpError2}
              </ErrorMessage>
              <Text>{copy.alreadyHaveAccount || <Placeholder h="20px" w="300px" />}</Text>
              <Link to={`/${locale}/salon-consultation/login`} href={`/${locale}/salon-consultation/login`}>
                <Anchor>{copy.signIn || <Placeholder h="20px" w="100px" />}</Anchor>
              </Link>
            </OverlayModal>
          ) : (
            <Spinner />
          )}
        </Overlay>
      </Wrapper>
    );
  }
}

CodeForm.defaultProps = {
  copy: {},
  errorMessage: {},
  terms: {
    copy: {
      date: '',
    },
    date: '',
    description: '',
  },
  // isCodeValid: null,
  loading: false,
  error: '',
};

CodeForm.propTypes = {
  copy: PropTypes.shape({}),
  errorMessage: PropTypes.shape({}),
  terms: PropTypes.shape({}),
  onInputChange: PropTypes.func.isRequired,
  onCodeSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isValidCodeForm: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  // isCodeValid: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

const mapState = state => ({
  terms: state.salonConsultaionSiteOptions.singUpTerms,
});

export default connect(mapState)(CodeForm);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SignUpPage/CodeForm.js